import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdElapsedTime',
  standalone: true,
})
export class ElapsedTimePipe implements PipeTransform {
  transform(
    input: number | null,
    units: string = 's',
    precision: string = 's',
    _longFormat: boolean = false,
    _languageId?: number
  ): string {
    if (input === null) {
      return '';
    }

    units = (units || 's').toLowerCase();
    precision = (precision || 's').toLowerCase();

    input = input || 0;

    if (input === Infinity || isNaN(input)) {
      input = 0;
    }

    // Convert to seconds
    if (units === 'h') {
      input = input * 60 * 60;
    } else if (units === 'm') {
      input = input * 60;
    } else if (units === 'd') {
      input = input * 60 * 60 * 24;
    }

    const oneMinute = 60;
    const oneHour: number = oneMinute * 60;
    const oneDay: number = oneHour * 24;

    const PRECISION_UNDEFINED = 0;
    const PRECISION_DAYS = 1;
    const PRECISION_HOURS = 2;
    const PRECISION_MINUTES = 3;
    const PRECISION_SECONDS = 4;

    const days = Math.floor(input / oneDay);
    input = input % oneDay;
    const hours = Math.floor(input / oneHour);
    input = input % oneHour;
    const minutes = Math.floor(input / oneMinute);
    input = input % oneMinute;
    const seconds = Math.floor(input);

    const parts = [];
    let precisionNum;
    if (precision === 'd') {
      precisionNum = PRECISION_DAYS;
    } else if (precision === 'h') {
      precisionNum = PRECISION_HOURS;
    } else if (precision === 'm') {
      precisionNum = PRECISION_MINUTES;
    } else {
      precisionNum = PRECISION_SECONDS;
    }

    let msb = PRECISION_UNDEFINED,
      lsb = PRECISION_UNDEFINED;
    if (days > 0) {
      msb = msb || PRECISION_DAYS;
      lsb = Math.min(precisionNum, PRECISION_DAYS);
    }
    if (hours > 0) {
      msb = msb || PRECISION_HOURS;
      lsb = Math.min(precisionNum, PRECISION_HOURS);
    }
    if (minutes > 0) {
      msb = msb || PRECISION_MINUTES;
      lsb = Math.min(precisionNum, PRECISION_MINUTES);
    }
    if (seconds > 0) {
      msb = msb || PRECISION_SECONDS;
      lsb = Math.min(precisionNum, PRECISION_SECONDS);
    }

    if (msb === PRECISION_UNDEFINED && lsb === PRECISION_UNDEFINED) {
      msb = precisionNum;
      lsb = precisionNum;
    }

    if ((days > 0 || msb <= PRECISION_DAYS) && lsb >= PRECISION_DAYS) {
      parts.push(days + 'd');
    }
    if ((hours > 0 || msb <= PRECISION_HOURS) && lsb >= PRECISION_HOURS) {
      parts.push(hours + 'h');
    }
    if ((minutes > 0 || msb <= PRECISION_MINUTES) && lsb >= PRECISION_MINUTES) {
      parts.push(minutes + 'm');
    }
    if ((seconds > 0 || msb <= PRECISION_SECONDS) && lsb >= PRECISION_SECONDS) {
      parts.push(seconds + 's');
    }

    return parts.join(' ');
  }
}
